import { User } from '@/modules/user/entities/user';
import jwtDecode from 'jwt-decode';

/**
 * Formato mínimo do usuário embutido no JWT. Preservamos o contrato atual
 * (`{ ...userDoJwt, scopes: me.scopes }`) e NÃO substituímos silenciosamente
 * o usuário armazenado pelo retorno inteiro de `/me`.
 */
interface TokenUser {
  id: string;
  name: string;
  email: string;
  type: User['type'];
}

interface TokenPayload {
  user?: TokenUser;
  exp: number;
}

/**
 * Persiste a sessão apenas quando o carregamento do `/me` terminou com sucesso.
 *
 * Valida o token (payload de usuário presente e `exp` futuro) antes de gravar.
 * Em caso de falha de storage, limpa resíduos para não deixar uma sessão
 * parcialmente pronta e relança o erro.
 *
 * Não libera acesso com os scopes do JWT como fallback: os scopes vêm sempre
 * do retorno de `/me`.
 */
export const commitSession = (token: string, me: User): void => {
  const payload = jwtDecode<TokenPayload>(token);

  if (!payload?.user?.id || !Number.isFinite(payload.exp) || payload.exp * 1000 <= Date.now()) {
    throw new Error('INVALID_OR_EXPIRED_SESSION_TOKEN');
  }

  try {
    localStorage.removeItem('company');
    localStorage.setItem(
      'user',
      JSON.stringify({
        ...payload.user,
        scopes: me.scopes,
      }),
    );
    localStorage.setItem('token', token);
  } catch (error) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('company');
    throw error;
  }

  window.dispatchEvent(new Event('sov-v2:auth'));
};
